module.exports = __webpack_public_path__ + "img/gzh.df6e5f9d.jpeg";